import type * as lazyIndex from './lazyIndex';
import { LazyAction, LazyModule, registerLazyOrchestrator } from 'owa-bundling';
import { onWin32StyleCommitted } from 'owa-theme-win32-style-store';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "Win32StyleComposePopout" */ './lazyIndex'),
    { name: 'Win32StyleComposePopout' }
);

export const lazyInitializeWin32StyleComposeFormOption: LazyAction<
    typeof lazyIndex.initializeWin32StyleComposeFormOption,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.initializeWin32StyleComposeFormOption);

registerLazyOrchestrator(
    onWin32StyleCommitted,
    lazyModule,
    m => m.applyWin32StyleComposeFormOptionOrchestrator
);
